import React, {Component} from 'react';
import ReactDOM from "react-dom";
import Loader from "./Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import pt_BR from 'date-fns/locale/pt-BR';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Axios from "axios";
import { chamadosSelectStyles as selectStyles, chamadosSelectComponents as reactSelectIcons } from "../util/chamadosSelectStyles";
registerLocale('pt-BR', pt_BR);

const ASSUNTO_ORDEM_FIXA = ['Erro no sistema', 'Outros'];

const sortAssuntoOutrosLast = (a, b) => {
    const posA = ASSUNTO_ORDEM_FIXA.indexOf(a);
    const posB = ASSUNTO_ORDEM_FIXA.indexOf(b);
    if (posA !== -1 && posB !== -1) return posA - posB;
    if (posA !== -1) return 1;
    if (posB !== -1) return -1;
    return a.localeCompare(b, 'pt-BR');
};

const EXP_BOLD = { fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 700 };
const STATUS_INLINE = { ...EXP_BOLD, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '2px 8px', borderRadius: 0, fontSize: '17px', lineHeight: 'normal', minWidth: '128px', width: '128px', whiteSpace: 'nowrap', textTransform: 'uppercase', textAlign: 'center' };

export default class ChamadosList extends Component {

    constructor(props) {
        super();

        this.state = {
            activeTab: props.gestorMode ? 'todos' : 'meus',
            chamados: [],
            loading: false,
            pagination: {
                total: 0,
                per_page: 20,
                current_page: 1,
                last_page: 1,
                from: 1,
                to: 0
            },
            filters: {
                status: '',
                assunto: '',
                observacao: '',
                name: '',
                empresa: '',
                cidade: null,
                cliente: null,
                responsavel: null,
                empreendimento: null,
                data_inicial: '',
                data_final: '',
                download: '',
            },
            assuntos: [
                'Inclusão de empreendimento',
                'Informações faltantes ou incorretas',
                'Erro no sistema',
                'Outros'
            ],
            observacoes: {
                'Informações faltantes ou incorretas': ['Localização', 'Estoque', 'Valor incorreto', 'Preço', 'Tipologia', 'Ficha técnica'],
                'Outros': ['Envio de material', 'Dúvida', 'Sugestão']
            },
            // "Aberto" continua existindo em chamados antigos/já criados, mas não é mais oferecido
            // como opção de filtro (pedido do cliente) — o badge dele continua sendo exibido normalmente.
            status: ['Em Atendimento', 'Finalizado'],
            user: null,
            exporting: false,
            usersFila: [],
        }
    }


    searchCidade = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await Axios.get('/cidades/json-options-with-state-on-values/' + inputQuery);
            return  response.data;

        }
    }

    searchCliente = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await Axios.get('/search-clients/' + inputQuery);
            return  response.data;
        }
    }

    loadUsersFila = async () => {
        try {
            const response = await Axios.get(route('chamado.users.fila'));
            this.setState({ usersFila: response.data });
        } catch (e) {
            console.log(e);
        }
    }

    searchEmpresa = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await Axios.get('/search-empresa/' + inputQuery);
            return response.data;
        }
    }


    loadData = async () => {
        try {
            await this.setLoading(true);

            let urlParams = { page: this.state.pagination.current_page };

            if (this.state.activeTab === 'meus') {
                urlParams.meus_chamados = 1;
            } else {
                const f = this.state.filters;
                if (f.status && f.status.length > 0)           urlParams.status        = f.status;
                if (f.assunto && f.assunto.length > 0)          urlParams.assunto       = f.assunto;
                if (f.observacao && f.observacao.length > 0)    urlParams.observacao_filter = f.observacao;
                if (f.name && f.name.length > 0)                urlParams.nome          = f.name;
                if (f.empresa && f.empresa.length > 0)          urlParams.empresa       = f.empresa;
                if (f.cidade)                                   { let p = f.cidade.value.split('-'); urlParams.cidade = p[0].trim(); urlParams.estado = p[1].trim(); }
                if (f.data_inicial !== '')                       urlParams.data_inicial  = new Date(f.data_inicial).toLocaleDateString('pt-BR');
                if (f.data_final   !== '')                       urlParams.data_final    = new Date(f.data_final).toLocaleDateString('pt-BR');
                if (f.cliente)                                  urlParams.cliente       = f.cliente.value;
                if (f.responsavel)                              urlParams.responsavel   = f.responsavel.value;
                if (f.empreendimento)                           urlParams.empreendimento = f.empreendimento.value;
                if (f.download !== '')                          urlParams.download      = true;
            }

            let requestExtraParams = {};
            if (this.state.filters.download !== '') requestExtraParams.responseType = 'blob';


            let response = await axios.get(route('chamados.data', urlParams ), requestExtraParams);

            if (response.status === 200) {


                if( response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ){
                    const type = response.headers['content-type']
                    const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = response.headers['content-disposition'].split('filename=')[1];
                    link.click()

                    this.setState({
                        ...this.state,
                         filters: {
                            ...this.state.filters,
                            download: ''
                        }
                    });

                    return;
                }


                this.setState({
                    ...this.state,
                    chamados: response.data.data,
                    pagination: {
                        total: response.data.total,
                        per_page: response.data.per_page,
                        current_page: response.data.current_page,
                        last_page: response.data.last_page,
                        from: response.data.from,
                        to: response.data.to
                    }, filters: {
                        ...this.state.filters,
                        download: ''
                    }
                });
            }
        } catch (e) {
            if( e.response && e.response.status === 422){
                this.setState({errors: e.response.data.errors});

            }
            console.log(e);
        }
        finally {
            await this.setLoading(false);
        }
    }

    setLoading = async (loading) => {

        await this.setState({
            loading: loading
        });
    }

    loadAuthUser = async () => {
        try {
            let response = await axios.get(route('user.auth'));
            if (response.status === 200) {
                this.setState({
                    ...this.state,
                    user: response.data
                });
            }
        } catch (e) {
            console.log(e);
        }
    }

    componentDidMount = async () => {

        try {
            await this.loadData();
            await this.loadAuthUser();
            if (this.props.gestorMode) {
                await this.loadUsersFila();
            }
        } catch (e) {
            console.log(e);
        }
    }

    switchTab = async (tab) => {
        await this.setState({
            activeTab: tab,
            pagination: { ...this.state.pagination, current_page: 1 },
            filters: { status: '', assunto: '', observacao: '', name: '', empresa: '', cidade: null, cliente: null, responsavel: null, empreendimento: null, data_inicial: '', data_final: '', download: '' },
        });
        await this.loadData();
    }

    applyFilters = async () => {
        await this.setState({ pagination: { ...this.state.pagination, current_page: 1 } });
        await this.loadData();
    }

    clearFilters = async () => {
        await this.setState({
            filters: { status: '', assunto: '', observacao: '', name: '', empresa: '', cidade: null, cliente: null, responsavel: null, empreendimento: null, data_inicial: '', data_final: '', download: '' },
            pagination: { ...this.state.pagination, current_page: 1 },
        });
        await this.loadData();
    }

    exportExcel = () => {
        this.setState({ exporting: true });
        const f = this.state.filters;
        let params = {};
        if (f.status)         params.status              = f.status;
        if (f.assunto)        params.assunto             = f.assunto;
        if (f.observacao)     params.observacao_filter   = f.observacao;
        if (f.name)           params.nome                = f.name;
        if (f.empresa)        params.empresa             = f.empresa;
        if (f.cidade)         { let p = f.cidade.value.split('-'); params.cidade = p[0].trim(); params.estado = p[1].trim(); }
        if (f.data_inicial)   params.data_inicial        = new Date(f.data_inicial).toLocaleDateString('pt-BR');
        if (f.data_final)     params.data_final          = new Date(f.data_final).toLocaleDateString('pt-BR');
        if (f.cliente)        params.cliente             = f.cliente.value;
        if (f.responsavel)    params.responsavel         = f.responsavel.value;
        if (f.empreendimento) params.empreendimento      = f.empreendimento.value;
        window.location.href = route('chamados.export', params);
        setTimeout(() => this.setState({ exporting: false }), 6000);
    }

    alterPage = async (page) => {
        await this.setState({
            ...this.state,
            pagination: {
                ...this.state.pagination,
                current_page: page
            }
        });

        await this.loadData();
    }

    searchEmpreendimentos = async (inputQuery) => {
        if ( inputQuery.length > 1 ) {
            try {

                let params = {
                    term : inputQuery
                };

                if (this.state.filters.cidade) {

                    let parts = this.state.filters.cidade.value.split('-');

                    params.cidade = parts[0];
                    params.estado = parts[1];
                }

                let endpoint = route('search-buildings', params );

                let empreendimentos = await axios.get( endpoint );

                return empreendimentos.data;
            } catch (error) {
                console.log(error);
            }
        }
    }

    handleNomeChanged = async (e) => {
        await this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                name: e.target.value
            }
        });

    }

                    render() {
        const { activeTab, filters, status, assuntos, observacoes, exporting, usersFila } = this.state;
        const statusLabels = { 'Em Atendimento': 'Andamento' };
        const statusOptions   = [...status].sort((a, b) => a.localeCompare(b, 'pt-BR')).map(s => ({ value: s, label: statusLabels[s] || s }));
        const assuntoOptions  = [...assuntos].sort(sortAssuntoOutrosLast).map(a => ({ value: a, label: a }));
        const observacaoOptions = (filters.assunto && observacoes[filters.assunto])
            ? [...observacoes[filters.assunto]].sort((a, b) => a.localeCompare(b, 'pt-BR')).map(o => ({ value: o, label: o }))
            : [];
        const responsavelOptions = [...usersFila]
            .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
            .map(u => ({ value: u.id, label: u.name }));

        const filtrosNode = activeTab === 'todos' && (
                <div style={{ marginBottom: '28px' }}>
                    {/* Linha 1: Data inicial | Data final | Status | Responsável */}
                    <div className="chamados-filter-row">
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Data de abertura inicial</label>
                            <div className="chamados-date-wrapper">
                                <DatePicker
                                    className="chamados-filter-input"
                                    selected={filters.data_inicial || null}
                                    onChange={date => this.setState({ filters: { ...filters, data_inicial: date || '' } })}
                                    dateFormat="dd/MM/yyyy"
                                    locale="pt-BR"
                                    placeholderText=""
                                    isClearable
                                />
                                <i className="far fa-calendar chamados-date-icon"></i>
                            </div>
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Data de abertura final</label>
                            <div className="chamados-date-wrapper">
                                <DatePicker
                                    className="chamados-filter-input"
                                    selected={filters.data_final || null}
                                    onChange={date => this.setState({ filters: { ...filters, data_final: date || '' } })}
                                    dateFormat="dd/MM/yyyy"
                                    locale="pt-BR"
                                    placeholderText=""
                                    isClearable
                                />
                                <i className="far fa-calendar chamados-date-icon"></i>
                            </div>
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Status</label>
                            <Select
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                options={statusOptions}
                                value={filters.status ? { value: filters.status, label: filters.status } : null}
                                onChange={opt => this.setState({ filters: { ...filters, status: opt ? opt.value : '' } })}
                            />
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Responsável</label>
                            <Select
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                options={responsavelOptions}
                                value={filters.responsavel}
                                onChange={opt => this.setState({ filters: { ...filters, responsavel: opt } })}
                            />
                        </div>
                    </div>
                    {/* Linha 2: Assunto | Observação | Cidade */}
                    <div className="chamados-filter-row">
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Assunto</label>
                            <Select
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                options={assuntoOptions}
                                value={filters.assunto ? { value: filters.assunto, label: filters.assunto } : null}
                                onChange={opt => this.setState({ filters: { ...filters, assunto: opt ? opt.value : '', observacao: '' } })}
                            />
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Observação</label>
                            <Select
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                isDisabled={!filters.assunto || observacaoOptions.length === 0}
                                options={observacaoOptions}
                                value={filters.observacao ? { value: filters.observacao, label: filters.observacao } : null}
                                onChange={opt => this.setState({ filters: { ...filters, observacao: opt ? opt.value : '' } })}
                            />
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Cidade</label>
                            <AsyncSelect
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                loadOptions={this.searchCidade}
                                value={filters.cidade}
                                onChange={opt => this.setState({ filters: { ...filters, cidade: opt, empreendimento: null } })}
                            />
                        </div>
                    </div>
                    {/* Linha 3: Empresa | Solicitante | Empreendimento | Empreendimento sugerido */}
                    <div className="chamados-filter-row">
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Empresa</label>
                            <AsyncSelect
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                loadOptions={this.searchEmpresa}
                                value={filters.empresa ? { value: filters.empresa, label: filters.empresa } : null}
                                onChange={opt => this.setState({ filters: { ...filters, empresa: opt ? opt.value : '' } })}
                            />
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Solicitante</label>
                            <AsyncSelect
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                loadOptions={this.searchCliente}
                                value={filters.cliente}
                                onChange={opt => this.setState({ filters: { ...filters, cliente: opt } })}
                            />
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Empreendimento</label>
                            <AsyncSelect
                                styles={selectStyles}
                                components={reactSelectIcons}
                                isClearable
                                placeholder="Selecione"
                                loadOptions={this.searchEmpreendimentos}
                                value={filters.empreendimento}
                                onChange={opt => this.setState({ filters: { ...filters, empreendimento: opt } })}
                            />
                        </div>
                        <div className="chamados-filter-field">
                            <label className="chamados-filter-label">Empreendimento sugerido</label>
                            <input
                                type="text"
                                className="chamados-filter-input"
                                placeholder="Digite"
                                value={filters.name}
                                onChange={this.handleNomeChanged}
                                style={{ fontFamily: "'Archivo Expanded', sans-serif", fontStyle: 'normal', fontWeight: 400, fontSize: '19px', color: '#5B595B' }}
                            />
                        </div>
                    </div>
                    <div className="chamados-filter-actions">
                        <button className="chamados-filter-apply" onClick={this.applyFilters}>FILTRAR</button>
                        <button
                            className={`chamados-filter-export${exporting ? ' chamados-filter-export--loading' : ''}`}
                            onClick={this.exportExcel}
                            disabled={exporting}
                        >
                            {exporting
                                ? <i className="fa fa-spinner fa-spin"></i>
                                : 'XLS'
                            }
                        </button>
                    </div>
                </div>
        );

        const tabelaNode = (<>
            <table className="chamados-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Status</th>
                        <th>Assunto</th>
                        <th>Solicitante</th>
                        {activeTab !== 'meus' && <th>Responsável</th>}
                        <th>Abertura</th>
                        <th>Fechamento</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.chamados.map((chamado, index) => {
                        const dataCriacao = new Date(chamado.created_at).toLocaleString('pt-BR', {
                            timeZone: 'America/Sao_Paulo',
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        let dataFinalizacao = '';
                        if(chamado.finished_at){
                            dataFinalizacao = new Date(chamado.finished_at).toLocaleString('pt-BR', {
                                timeZone: 'America/Sao_Paulo',
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit'
                            });
                        }
                        return(
                            <tr key={index}>
                                <td>{chamado.id}</td>
                                <td>
                                    {chamado.status == "Aberto" && <span className="status-badge status-aberto" style={{ ...STATUS_INLINE, background: '#4D5830', color: '#fff' }}>Aberto</span>}
                                    {chamado.status == "Finalizado" && <span className="status-badge status-finalizado" style={{ ...STATUS_INLINE, background: '#4D5A31', color: '#fff' }}>Finalizado</span>}
                                    {chamado.status == "Em Atendimento" && <span className="status-badge status-andamento" style={{ ...STATUS_INLINE, background: '#F3CE00', color: '#4D5830' }}>Andamento</span>}
                                </td>
                                <td>{chamado.subject}</td>
                                <td>{chamado.name}</td>
                                {activeTab !== 'meus' && <td>{chamado.responsible_name || '—'}</td>}
                                <td>{dataCriacao}</td>
                                <td>{dataFinalizacao}</td>
                                <td>
                                    <a href={route('chamado.show', chamado.id)} className="btn-ver-chamado" title="Ver detalhes">
                                        <img src="/img/ico_view.png" alt="Ver detalhes" />
                                    </a>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            {this.state.pagination.last_page > 1 && (
                <div className="chamados-pagination">
                    {this.state.pagination.current_page > 1 && (
                        <span className="page-item">
                            <a
                                className="page-link page-nav-text"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.alterPage(this.state.pagination.current_page - 1);
                                }}>
                                Anterior
                            </a>
                        </span>
                    )}

                    {[...Array(this.state.pagination.last_page)].map((page, index) => {
                        let pageNumber = index + 1;
                        if (pageNumber >= this.state.pagination.current_page - 2 && pageNumber <= this.state.pagination.current_page + 2) {
                            return (
                                <span key={index} className={pageNumber === this.state.pagination.current_page ? 'page-item active' : 'page-item'}>
                                    <a
                                        className="page-link"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.alterPage(pageNumber);
                                        }}>
                                        {pageNumber}
                                    </a>
                                </span>
                            );
                        }
                    })}

                    {this.state.pagination.current_page < this.state.pagination.last_page && (
                        <span className="page-item">
                            <a
                                className="page-link page-nav-text"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.alterPage(this.state.pagination.current_page + 1);
                                }}>
                                Próximo
                            </a>
                        </span>
                    )}

                </div>
            )}
        </>);

        const loaderNode = this.state.loading && (
            <div className="chamados-loader-overlay">
                <div className="chamados-loader-container">
                    <Loader/>
                </div>
            </div>
        );

        if (this.props.gestorMode) {
            return (<>
                {loaderNode}

                {/* Painel Gerenciamento */}
                <div className="card chamados-card">
                    <div className="card-header chamados-card-header">
                        <h2 className="chamados-subtitle">Gerenciamento</h2>
                    </div>
                    <hr className="chamados-divider" />
                    <div className="chamados-list-body">
                        {filtrosNode}
                    </div>
                </div>

                {/* Painel Chamados */}
                <div className="chamados-card" style={{ marginTop: '40px' }}>
                    <h2 className="chamados-subtitle" style={{ padding: '0 30px', fontSize: '23px' }}>Meus Chamados</h2>
                    <div className="chamados-list-body">
                        {tabelaNode}
                    </div>
                </div>
            </>);
        }

        return (<>
            {loaderNode}

            {/* Título */}
            <div className="card-header chamados-card-header">
                <h2 className="chamados-subtitle" style={{ fontSize: '23px' }}>Meus Chamados</h2>
            </div>
            <hr className="chamados-divider" />

            <div className="chamados-list-body">
                {filtrosNode}
                {tabelaNode}
            </div>
        </>);
    }
}


if (document.getElementById('js-list-chamados')) {
    const listElement = document.getElementById('js-list-chamados');
    ReactDOM.render(<ChamadosList gestorMode={listElement.dataset.gestorMode === '1'}/>, listElement);
}

if (document.getElementById('js-gestor-chamados')) {
    ReactDOM.render(<ChamadosList gestorMode={true}/>, document.getElementById('js-gestor-chamados'));
}
